const salesOrder = `${process.env.baseUrl}/sales/order/`;

export default {
    salesOrderHistory: `${salesOrder}history`,
    salesOrderView: `${salesOrder}view/order_id/`,
    repaymentLink: `${salesOrder}repayment/order_id/{id}`,
    allOrders: `${salesOrder}/view`,
};
